import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { baseUrl } from "../../utils";

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../loader";

const Review = ({ prevComponent }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const childrenInformations = useSelector(
    (state) => state.account.createAccount.childrenInformations
  );

  const guardianInformations = useSelector(
    (state) => state.account.createAccount.guardianInformations
  );

  const navigate = useNavigate();

  const createAccount = useSelector((state) => state.account.createAccount);

  const SubmitCreateAccount = async (e) => {
  setIsLoading(true);
  const authToken = sessionStorage.getItem("bvnAuthToken");
  
  // console.log("🔵 SubmitCreateAccount - Started");
  // console.log("🟡 Auth Token:", authToken);
  // console.log("🟡 Full Request Payload:", JSON.stringify({ createAccount }, null, 2));
  // console.log("🟡 API URL:", `${baseUrl}/kidsaccountopeningapi/api/v1/AccountOpening/CreateAccount`);
  
  // Validate critical data before sending
  if (!authToken) {
    // console.log("🔴 No authentication token found");
    setIsLoading(false);
    Swal.fire({
      icon: "error",
      title: "Authentication required",
      text: "Please login again"
    });
    return;
  }

  if (!createAccount?.childrenInformations?.length || !createAccount?.guardianInformations?.length) {
    // console.log("🔴 Missing required child or guardian information");
    setIsLoading(false);
    Swal.fire({
      icon: "error",
      title: "Incomplete data",
      text: "Please fill all required fields"
    });
    return;
  }

  try {
    const response = await axios.post(
      `${baseUrl}/kidsaccountopeningapi/api/v1/AccountOpening/CreateAccount`,
      { createAccount },
      {
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        },
        timeout: 30000
      }
    );

    // console.log("🟢 API Response - Success:");
    // console.log("🟢 Response Status:", response.status);
    // console.log("🟢 Response Data:", response.data);
    
    if (response.data.responseCode === "00") {
      // console.log("🟢 Success - Navigating to success page");
      navigate("/openKiddiesAccount/success");
    } else {
      // console.log("🟡 API returned non-00 response code:", response.data.responseCode);
      // console.log("🟡 Response Message:", response.data.responseMessage);
      
      Swal.fire({
        icon: "error",
        title: "Request Failed",
        text: response.data.responseMessage || `Error: ${response.data.responseCode}`
      });
    }
    
  } catch (error) {
    // console.log("🔴 API Error Details:");
    
    if (error.response) {
      // Server responded with error status
      // console.log("🔴 Response Status:", error.response.status);
      // console.log("🔴 Response Data:", error.response.data);
      // console.log("🔴 Response Headers:", error.response.headers);
    } else if (error.request) {
      // Request made but no response received
      // console.log("🔴 No Response Received - Network Error");
      // console.log("🔴 Request:", error.request);
    } else {
      // Something else happened
      // console.log("🔴 Error Message:", error.message);
    }
    
    // console.log("🔴 Full Error:", error);
    
    Swal.fire({
      icon: "error",
      title: "Network Error",
      text: error.response?.data?.responseMessage || "Please check your connection and try again"
    });
  } finally {
    setIsLoading(false);
    // console.log("🟡 SubmitCreateAccount - Finished");
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      SubmitCreateAccount();
      // setIsLoading(false);
    } catch (error) {
      // console.log(error).error(error.message);
      setIsLoading(false);
    }
  };

  const handlePrevClick = () => {
    prevComponent();
  };
  return (
    <div className="page">
      <div className="flex-column">
        <div className="kiddies_hero"></div>

        <div className="kiddies_hero-tablet"></div>

        <div className="kiddies_hero-mobile"></div>

        <div className="col-lg-12  m-b-50 ">
          <section className="step-wizard m-b-30">
            <ul className="step-wizard-list">
              <li className="step-wizard-item m-b-10">
                <span className="progress-count">1</span>
                <span className="progress-title">Introduction</span>
              </li>
              <li className="step-wizard-item">
                <span className="progress-count">2</span>
                <span className="progress-title">Child Information</span>
              </li>
              <li className="step-wizard-item">
                <span className="progress-count">3</span>
                <span className="progress-title">
                  Parent / Guardian Information
                </span>
              </li>
              <li className="step-wizard-item">
                <span className="progress-count">4</span>
                <span className="progress-title">Upload Documents</span>
              </li>
              <li className="step-wizard-item current-item">
                <span className="progress-count">5</span>
                <span className="progress-title">Review Information</span>
              </li>
            </ul>
          </section>

          <section className="step-wizard-tablet m-b-30">
            <ul className="step-wizard-list">
              <li className="step-wizard-item m-b-10">
                <span className="progress-count">1</span>
                <span className="progress-title">Introduction</span>
              </li>
              <li className="step-wizard-item current-item">
                <span className="progress-count">2</span>
                <span className="progress-title">Child Information</span>
              </li>
              <li className="step-wizard-item">
                <span className="progress-count">3</span>
                <span className="progress-title">
                  Parent / Guardian Information
                </span>
              </li>
              <li className="step-wizard-item">
                <span className="progress-count">4</span>
                <span className="progress-title">Upload Documents</span>
              </li>
              <li className="step-wizard-item">
                <span className="progress-count">5</span>
                <span className="progress-title">Review Information</span>
              </li>
            </ul>
          </section>

          <div className="tab-content p-30" id="myTabContent">
            <div
              className="fade show active"
              id="account_spec"
              role="tabpanel"
              aria-labelledby="account_spec-tab"
            >
              {/* <!-- CHILD INFORMATION --> */}
              <div className="section-info m-b-50">
                <div className="section-title font-weight-500 font-24 m-b-10 border-bottom p-1 text-suntrust">
                  <i className="fa fa-child m-r-5"></i> Child Information
                </div>

                {/* <!-- <div className="row"> --> */}

                {/* <!-- Personal Information --> */}
                <div className="main-section d-flex border-bottom m-t-10">
                  <div className="col-lg-3 col-md-12 col-sm-12 m-r-30 m-b-10">
                    <div className="font-weight-500 font-16 m-b-10">
                      Children Information
                    </div>
                  </div>

                  <div className="section-forms p-10 col-lg-9 col-md-12 col-sm-12">
                    <div className="col-lg-12">
                      <div className="row">
                        <div className="table-responsive border">
                          <table className="table table-hover mb-0 c_list">
                            <thead
                              className="font-weight-500"
                              style={{ backgroundColor: "#eee" }}
                            >
                              <tr>
                                <th>S/N</th>
                                <th>Firstname</th>
                                <th>Lastname</th>
                                <th>Date of Birth</th>
                                <th>Gender</th>

                                <th className="d-flex align-items-center justify-content-center">
                                  Religion
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {childrenInformations.map((child, index) => {
                                index = index === 0 ? 1 : index + 1;
                                return (
                                  <tr key={index}>
                                    <td>{index}</td>
                                    <td>{child.firstName}</td>
                                    <td>{child.surName}</td>
                                    <td>{child.dateOfBirth}</td>

                                    <td>{child.gender.split("#")[1]}</td>

                                    <td className="d-flex align-items-center justify-content-center">
                                      {child.religion.split("#")[1]}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <!-- School Information --> */}
                <div className="main-section d-flex border-bottom m-t-10">
                  <div className="col-lg-3 col-md-12 col-sm-12 m-r-30 m-b-10">
                    <div className="font-weight-500 font-16 m-b-10">
                      School Information
                    </div>
                  </div>

                  <div className="section-forms p-10 col-lg-9 col-md-12 col-sm-12">
                    <div className="col-lg-12">
                      <div className="row">
                        <div className="table-responsive border">
                          <table className="table table-hover mb-0 c_list">
                            <thead
                              className="font-weight-500"
                              style={{ backgroundColor: "#eee" }}
                            >
                              <tr>
                                <th>S/N</th>
                                <th>Firstname</th>
                                <th>Lastname</th>
                                <th>Gender</th>
                                <th>School Name</th>
                                {/* <th>Child's className</th> */}
                                <th className="d-flex align-items-center justify-content-center">
                                  Child's class/grade
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {childrenInformations.map((child, index) => {
                                index = index === 0 ? 1 : index + 1;
                                return (
                                  <tr key={index}>
                                    <td>{index}</td>
                                    <td>{child.firstName}</td>
                                    <td>{child.surName}</td>
                                    <td>{child.gender.split("#")[1]}</td>
                                    <td>{child.schoolName}</td>
                                    {/* <td>{child.childClass}</td> */}
                                    <td className="d-flex align-items-center justify-content-center">
                                      {child.childClass}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Parent / Guardian Information --> */}
              <div className="section-info m-b-50">
                <div className="section-title font-weight-500 font-24 m-b-10 border-bottom p-1 text-suntrust">
                  <i className="fa fa-user m-r-5"></i> Parent / Guardian
                  Information
                </div>

                {/* <!-- <div className="row"> --> */}

                {/* <!-- Personal Information --> */}
                <div className="main-section d-flex border-bottom m-t-10">
                  <div className="col-lg-3 col-md-12 col-sm-12 m-r-30 m-b-10">
                    <div className="font-weight-500 font-16 m-b-10">
                      Personal Information
                    </div>
                  </div>

                  <div className="section-forms p-10 col-lg-9 col-md-12 col-sm-12">
                    <div className="col-lg-12">
                      <div className="row">
                        <div className="table-responsive border">
                          <table className="table table-hover mb-0 c_list">
                            <thead
                              className="font-weight-500"
                              style={{ backgroundColor: "#eee" }}
                            >
                              <tr>
                                <th>S/N</th>
                                <th>Firstname</th>
                                <th>Lastname</th>
                                <th>Gender</th>
                                <th>Mobile Number</th>
                                <th>Email</th>
                                {/* <th>Relationship</th> */}
                                <th className="d-flex align-items-center justify-content-center">
                                  Relationship
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {guardianInformations.map((guardian, index) => {
                                index = index === 0 ? 1 : index + 1;
                                return (
                                  <tr key={index}>
                                    <td>{index}</td>
                                    <td>{guardian.firstName}</td>
                                    <td>{guardian.surName}</td>
                                    <td>{guardian.gender}</td>
                                    <td>{guardian.mobileNumber}</td>
                                    <td>{guardian.emailAddress}</td>
                                    {/* <td>{guardian.relationship}</td> */}
                                    <td className="d-flex align-items-center justify-content-center">
                                      {guardian.relationship}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <!-- Means of Identification --> */}
                <div className="main-section d-flex border-bottom m-t-10">
                  <div className="col-lg-3 col-md-12 col-sm-12 m-r-30 m-b-10">
                    <div className="font-weight-500 font-16 m-b-10">
                      Means of Identification
                    </div>
                  </div>

                  <div className="section-forms p-10 col-lg-9 col-md-12 col-sm-12">
                    <div className="col-lg-12">
                      <div className="row">
                        <div className="table-responsive border">
                          <table className="table table-hover mb-0 c_list">
                            <thead
                              className="font-weight-500"
                              style={{ backgroundColor: "#eee" }}
                            >
                              <tr>
                                <th>S/N</th>
                                <th>Firstname</th>
                                <th>Lastname</th>
                                {/* <th>ID Type</th> */}
                                <th>ID Number</th>
                                <th>Date of Issue</th>
                                {/* <th>Expiry Date</th> */}
                                <th className="d-flex align-items-center justify-content-center">
                                  Expiry Date
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {guardianInformations.map((guardian, index) => {
                                index = index === 0 ? 1 : index + 1;
                                return (
                                  <tr key={index}>
                                    <td>{index}</td>
                                    <td>{guardian.firstName}</td>
                                    <td>{guardian.surName}</td>

                                    <td>{guardian.idNumber}</td>
                                    <td>{guardian.dateIssue}</td>

                                    <td className="d-flex align-items-center justify-content-center">
                                      {guardian.permitExpiryDate}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- </div> --> */}
            </div>

            {/* <!-- UPLOADED DOCUMENTS --> */}
            <div className="section-info m-b-50">
              <div className="section-title font-weight-500 font-24 m-b-10 border-bottom p-1 text-suntrust">
                <i className="fa fa-files-o m-r-5"></i> Uploaded Documents
              </div>

              {/* <!-- <div className="row"> --> */}
              {/* <!-- Uploaded Documents --> */}
              <div className="main-section d-flex border-bottom m-t-10">
                <div className="col-lg-3 col-md-12 col-sm-12 m-r-30 m-b-10">
                  <div className="font-weight-500 font-16 m-b-10">
                    Documents
                  </div>
                </div>

                <div className="section-forms p-10 col-lg-9 col-md-12 col-sm-12">
                  <div className="col-lg-12">
                    <div className="row">
                      <div className="form-group col-lg-12 col-md-12 col-sm-12 font-weight-500 m-b-30">
                        <div className="table-responsive border">
                          <table className="table table-hover mb-0 c_list">
                            <thead
                              className="font-weight-500"
                              style={{ backgroundColor: "#eee" }}
                            >
                              <tr>
                                {/* <th>Title</th> */}
                                <th>Child Name</th>
                                <th>Title</th>
                                <th className="d-flex align-items-center justify-content-center">
                                  Attachment
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {childrenInformations.map((child) => {
                                return child.documents.map((doc) => {
                                  return (
                                    <tr key={doc.name}>
                                      <td>{`${child.firstName} ${child.surName}`}</td>

                                      <td>{doc.documentType.split("#")[1]}</td>

                                      <td className="d-flex align-items-center justify-content-center">
                                        {doc.name}
                                      </td>
                                    </tr>
                                  );
                                });
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="form-group col-lg-12 col-md-12 col-sm-12 font-weight-500 m-b-30">
                        <div className="table-responsive border">
                          <table className="table table-hover mb-0 c_list">
                            <thead
                              className="font-weight-500"
                              style={{ backgroundColor: "#eee" }}
                            >
                              <tr>
                                {/* <th>Title</th> */}
                                <th>Guardian/Parents' Name</th>
                                <th>Title</th>
                                <th className="d-flex align-items-center justify-content-center">
                                  Attachment
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {guardianInformations.map((child) => {
                                return child.documents.map((doc) => {
                                  return (
                                    <tr key={doc.name}>
                                      <td>{`${child.firstName} ${child.surName}`}</td>

                                      <td>{doc.documentType.split("#")[1]}</td>

                                      <td className="d-flex align-items-center justify-content-center">
                                        {doc.name}
                                      </td>
                                    </tr>
                                  );
                                });
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- </div> --> */}
            </div>
          </div>

          <div className="form-group col-lg-12 col-md-12 col-sm-12 m-b-20">
            <div className="d-flex align-items-center justify-content-center m-t-20">
              <div className="user_acct_details col-lg-3 col-md-6 col-sm-12 m-b-10">
                <button
                  href="upload_docs.html"
                  className="btn btn-block btn-suntrust font-weight-500"
                  onClick={handlePrevClick}
                >
                  Previous Page
                </button>
              </div>

              <div className="user_acct_details col-lg-3 col-md-6 col-sm-12 m-b-10">
                <button
                  className="btn btn-block btn-suntrust font-weight-500"
                  onClick={handleSubmit}
                >
                  {isLoading ? <Loader /> : " Create Account"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Review;
